import { SearchLenseIcon } from '@/_components/icons';

import Button from '../third_party/button';
import { H4, SubTitle2 } from '../typography';

const ErrorFallback = () => {
  const refresh = () => {
    window.location.reload();
  };

  return (
    <section className="min-h-screen bg-background-default">
      <article className="flex flex-col items-center justify-center pt-[84px] md:pt-[225px]">
        <SearchLenseIcon className="text-8xl text-primary-light md:text-[9rem]" />
        <H4>Oops, something went wrong.</H4>
        <div className="my-4 max-w-[30.3125rem] text-center">
          <SubTitle2>
            We’re looking into it. In the meantime, please try refreshing the page or coming back later.
          </SubTitle2>
        </div>
        <Button variant="contained" onClick={refresh} className="w-48">
          Retry
        </Button>
      </article>
    </section>
  );
};

export default ErrorFallback;
